import React from 'react';
import { formatDateTime } from '../../utils/formatDate';
import { ShieldAlert, CheckCircle, XCircle, ArrowUpRight } from 'lucide-react';
import Badge from '../common/Badge';

const ChatBubble = ({ message, currentUserId, onApproveLimit, onRejectLimit }) => {
  const isMine = message.senderModel === 'SuperAdmin' || (currentUserId && String(message.senderId) === String(currentUserId));

  return (
    <div className={`flex flex-col ${isMine ? 'items-end' : 'items-start'} my-2`}>
      <div
        className={`max-w-xs sm:max-w-md px-4 py-3 rounded-2xl text-xs sm:text-sm shadow-md transition ${
          isMine
            ? 'bg-gradient-to-r from-green-700 to-green-600 text-slate-900 rounded-br-none'
            : 'bg-white border border-slate-100 text-slate-700 rounded-bl-none'
        }`}
      >
        <p className="whitespace-pre-wrap leading-relaxed">{message.message}</p>

        {/* Actionable Limit Increase Card */}
        {message.isLimitRequest && message.limitDetails && (
          <div className="mt-3 p-3 rounded-xl bg-white/80 border border-slate-100 text-xs">
            <div className="flex items-center justify-between mb-2">
              <span className="flex items-center space-x-1 font-semibold text-amber-600">
                <ShieldAlert className="w-3.5 h-3.5" />
                <span>Employee Limit Request</span>
              </span>
              <Badge variant={message.limitDetails.status}>{message.limitDetails.status}</Badge>
            </div>

            <div className="space-y-1 text-slate-600 text-xs mb-3">
              <p>Current Limit: <span className="font-semibold text-slate-900">{message.limitDetails.currentLimit}</span></p>
              <p>Requested Limit: <span className="font-semibold text-green-700">{message.limitDetails.requestedLimit}</span></p>
              {message.limitDetails.reason && (
                <p className="text-slate-500 italic">"{message.limitDetails.reason}"</p>
              )}
            </div>

            {/* Approve / Reject buttons for Super Admin */}
            {message.limitDetails.status === 'Pending' && !isMine && (
              <div className="flex items-center space-x-2 pt-2 border-t border-slate-100">
                <button
                  onClick={() => onApproveLimit(message._id, message.limitDetails.requestedLimit)}
                  className="flex-1 py-1.5 px-3 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-slate-900 font-medium text-xs transition flex items-center justify-center space-x-1"
                >
                  <CheckCircle className="w-3.5 h-3.5" />
                  <span>Approve</span>
                </button>
                <button
                  onClick={() => onRejectLimit(message._id)}
                  className="flex-1 py-1.5 px-3 rounded-lg bg-rose-600 hover:bg-rose-500 text-slate-900 font-medium text-xs transition flex items-center justify-center space-x-1"
                >
                  <XCircle className="w-3.5 h-3.5" />
                  <span>Reject</span>
                </button>
              </div>
            )}
          </div>
        )}

        <span className={`block text-[10px] mt-1.5 ${isMine ? 'text-green-200/80 text-right' : 'text-slate-500'}`}>
          {formatDateTime(message.createdAt)}
        </span>
      </div>
    </div>
  );
};

export default ChatBubble;
